'use es6';

import ActivityFeed from './ActivityFeed';
import MarketingPerformance from './MarketingPerformance';
import { DealForecast } from './DealForecast';
import Persona from './Persona';
import Waterfall from './Waterfall';
import PipelineSnapshots from './PipelineSnapshots';
import DealPushAnalysis from './DealPushAnalysis';
import ChangeHistoryDealList from './ChangeHistoryDealList';
import SalesQuota from './SalesQuota';
import Widgets from './constants/widgets';
const wrapPromise = Component => () => Promise.resolve(Component);
export default {
  [Widgets.ACTIVITY_FEED]: wrapPromise(ActivityFeed),
  [Widgets.MARKETING_PERFORMANCE]: wrapPromise(MarketingPerformance),
  [Widgets.DEAL_FORECAST]: () => Promise.resolve(DealForecast),
  [Widgets.PERSONA]: wrapPromise(Persona),
  [Widgets.WATERFALL]: wrapPromise(Waterfall),
  [Widgets.CHANGE_HISTORY_DEAL_LIST]: wrapPromise(ChangeHistoryDealList),
  [Widgets.DEAL_PUSH_ANALYSIS]: wrapPromise(DealPushAnalysis),
  [Widgets.PIPELINE_SNAPSHOTS]: wrapPromise(PipelineSnapshots),
  [Widgets.SALES_QUOTA]: wrapPromise(SalesQuota),
  [Widgets.TASKS_STREAM]: () => import( /* webpackChunkName: "PlatformReport__StreamReports" */'./TasksStream').then(module => module.default)
};